module.exports = "/lucky-balls/img/weager/Background_image.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Background_image.png
// module id = 1156
// module chunks = 0